import Grid from '@mui/material/Grid2';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';

interface IProps {
    title: string;
    children: React.ReactNode;
    disabled?: boolean;
    width?: number;
    defaultExpanded?: boolean;
}

export default function CustomCollapse(props: IProps) {
    const { title, children, disabled, width, defaultExpanded = false } = props;
    const [toggleSelf, setToggleSelf] = useState(defaultExpanded);

    useEffect(() => {
        setToggleSelf(defaultExpanded);
    }, [defaultExpanded]);

    return (
        <Grid size={width ? width : 12} component={Paper}>
            <Grid size={12}>
                <ButtonBase disabled={disabled} disableRipple onClick={() => setToggleSelf(!toggleSelf)} sx={{ width: '100%' }}>
                    <Grid container justifyContent="space-between" spacing={2}>
                        <Grid>
                            <Typography variant={"h6"}>{title}</Typography>
                        </Grid>
                        <Grid>
                            <ExpandMoreIcon sx={{ transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms', transform: toggleSelf ? 'rotate(180deg)' : '' }} />
                        </Grid>
                    </Grid>
                </ButtonBase>
            </Grid>
            <Grid size={12}>
                <Collapse in={toggleSelf} sx={{
                    maxHeight: '700px', // Set the maximum height
                    overflow: 'auto', // Add scrolling if content exceeds max height
                }}>
                    {children}
                </Collapse>
            </Grid>
        </Grid >
    );
}
